import { AudienceDto, CreateAudienceDto } from "@intelligems/ig-types";

export interface IAudienceState {
  isSuccess: boolean;
  audience: CreateAudienceDto | AudienceDto | undefined;
  storedAudience: CreateAudienceDto | AudienceDto | undefined;
  campaignBeingEditedAudience: CreateAudienceDto | AudienceDto | undefined;
}

export const initialIAudienceState: IAudienceState = {
  isSuccess: false,
  audience: undefined,
  storedAudience: undefined,
  campaignBeingEditedAudience: undefined,
};
